import { colors } from 'theme'

export const defaultThemeStyles = {
    background: colors.darkCloud,
    text: colors.white,
}
